import { toast } from 'sonner';

import { graphql } from '@/lib/__generated__';
import {
  Eat_CartFragment,
  Eat_Cart_UpdateItem_Input,
} from '@/lib/__generated__/graphql';
import { apolloClient } from '@/lib/apollo/apollo-client';
import { getAnonId } from '@/lib/utils';

export async function updateItemInCart(
  input: Eat_Cart_UpdateItem_Input,
): Promise<Eat_CartFragment> {
  const response = await apolloClient.mutate({
    mutation: graphql(`
      mutation Eat_Cart_UpdateItem(
        $input: Eat_Cart_UpdateItem_Input!
        $anonId: ID!
      ) {
        Eat_Cart_UpdateItem(input: $input, anonId: $anonId) {
          cart {
            ...Eat_Cart
          }
        }
      }
    `),
    variables: {
      input,
      anonId: getAnonId(),
    },
  });

  const cart = response.data?.Eat_Cart_UpdateItem.cart;

  if (!cart) {
    toast.error('An error occurred', { position: 'top-center' });
    throw new Error('No cart returned from server');
  }

  return cart;
}
